import { ActivityComponentType } from '@stackflow/react'
import useTranslation from '../../../modules/i18n/useTranslation'
import { ExperiencedMaterials } from '../../../pages/[lang]/portal/my-ringle/materials/prev'
import { useMaterialsStack } from '../../../pages/[lang]/webview/materials'
import WebviewStackContainer from '../common/WebviewStackContainer'

const MaterialsPrevActivity: ActivityComponentType = () => {
  const { t } = useTranslation()
  const { useMaterialsFlow } = useMaterialsStack()
  const { pop } = useMaterialsFlow()

  return (
    <WebviewStackContainer height="52px" onBack={pop}>
      <ExperiencedMaterials />
    </WebviewStackContainer>
  )
}

export default MaterialsPrevActivity
